import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-upload-req-step-upload',
  templateUrl: './upload-req-step-upload.component.html'
})
export class UploadReqStepUploadComponent implements AfterViewInit, OnChanges, OnDestroy {

  @Input() currentJobStatus;
  @Input() editModeFlag;
  @Input() userDetails;
  @Input() clientOrBuList: any[] = [];
  @Input() clientOrBuIsRequiredFlag;
  @Input() req: any = {};
  @Input() job: any = {};
  @Input() sharedClientBus: any[] = [];
  @Input() sharedClientBuOrCorp: any;
  @Input() isLoadingSharedClientBus;
  @Input() isClientOrBuDisabled;
  @Input() isClientOrBuRequired;
  @Input() isUploadRequisition;
  @Input() isUploadAndEditRadioBtn;
  @Input() disableUploadButtonFlag;
  @Input() fileUploadInProgressFlag;
  @Input() step1Error: any = {};
  @Input() isJobFetched;
  @Input() isLoading;
  @Input() requisitionSkillsLoading;
  @Input() allExistingSkills;
  @Input() allExistingDegrees;
  @Input() allExistingFieldOfStudy;
  @Input() allExistingRoles;
  @Input() allExistingCertificates;
  @Input() allExistingJDActionWords;
  @Input() timePeriods;
  @Input() skillsTimePeriods;
  @Input() dropzoneConfig: DropzoneConfigInterface;

  @Output() clientChangeCallback = new EventEmitter<void>();
  @Output() sharedClientBuOrCorpChangeCallback = new EventEmitter<any>();
  @Output() uploadRequisitionTypeChangeCallback = new EventEmitter<boolean>();
  @Output() uploadRequisitionCallback = new EventEmitter<void>();
  @Output() updateLocationCallback = new EventEmitter<void>();
  @Output() showJobProfileCallback = new EventEmitter<void>();
  @Output() dropzoneFormReadyCallback = new EventEmitter<void>();
  @Output() fileAddedCallback = new EventEmitter<any>();
  @Output() fileRemovedCallback = new EventEmitter<any>();
  @Output() fileSendingCallback = new EventEmitter<any>();
  @Output() fileSuccessCallback = new EventEmitter<any>();
  @Output() fileErrorCallback = new EventEmitter<any>();

  @ViewChild(DropzoneDirective) reqUploadDropzoneDirective: DropzoneDirective;

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  private viewInitialized = false;
  private dropzoneFormReadyEmitted = false;

  ngAfterViewInit() {
    this.viewInitialized = true;
    // The dropzone plugin needs the #reqUploadDropzone form attached to the
    // live DOM. That form only renders when isUploadRequisition is true, so
    // wait for it rather than firing unconditionally on view init.
    this.emitDropzoneReadyIfApplicable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isUploadRequisition) {
      if (this.isUploadRequisition) {
        this.emitDropzoneReadyIfApplicable();
      } else {
        this.dropzoneFormReadyEmitted = false;
      }
    }
  }

  ngOnDestroy() {
  }

  private emitDropzoneReadyIfApplicable() {
    if (!this.viewInitialized || !this.isUploadRequisition || this.dropzoneFormReadyEmitted) {
      return;
    }
    this.dropzoneFormReadyEmitted = true;
    setTimeout(() => {
      this.dropzoneFormReadyCallback.emit();
    }, 300);
  }

  onClientIdChange(id: any) {
    if (!this.req.clientOrBU) {
      this.req.clientOrBU = {};
    }
    this.req.clientOrBU.id = id;
    this.clientChangeCallback.emit();
  }

  onSharedClientBuOrCorpChange(id: any) {
    const bu = (this.sharedClientBus || []).find((b) => String(b.id) === String(id));
    this.sharedClientBuOrCorpChangeCallback.emit(bu);
  }

  onUploadRequisitionTypeChange(isUploadRequisition: boolean) {
    this.uploadRequisitionTypeChangeCallback.emit(isUploadRequisition);
  }

  trackById(index: number, item: any) {
    return item && item.id;
  }

  onReqUploadFileAdded(file: any) {
    this.fileAddedCallback.emit(file);
  }

  onReqUploadFileRemoved(args: any) {
    this.fileRemovedCallback.emit(args);
  }

  onReqUploadFileSending(args: any) {
    this.fileSendingCallback.emit(args);
  }

  onReqUploadFileSuccess(args: any) {
    this.fileSuccessCallback.emit(args);
  }

  onReqUploadFileError(args: any) {
    this.fileErrorCallback.emit(args);
  }
}
